<template>
  <div class="dataTables_wrapper dt-bootstrap" id="example1_wrapper">
    <div class="row">
      <div class="col-sm-12 table-responsive p-x-0">
        <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
          <thead>
          <tr role="row">
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class=""><input v-model="selectAllItem" type="checkbox" @change="selectAll" /></th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" style="min-width: 180px">{{type === 'alias' ? '別名' : '描述（上限 500 字）'}}</th>
            <th v-if="type === 'description'" colspan="1" rowspan="1" aria-controls="example1" tabindex="0" style="min-width: 180px">警語（上限 200 字）</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品名稱</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品料號</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">啟用</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="actions-td">品項編輯</th>
            <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="actions-td">品項刪除</th>
          </tr>
          </thead>
          <tbody v-if="!settingList.length">
            <tr style="background-color: white">
              <td rowspan="1" colspan="12" style="text-align: center; padding-bottom: 80px; padding-top:80px;">
                <img src="/static/img/noMatchdata.svg" style="max-width: 148px;" class="center-block logo">
                <span style="margin-bottom: 80px; color: #696969;">無資料</span>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="even" role="row" v-for="(item, index) in settingList">
              <td><input type="checkbox" v-model="item.selectItem"/></td>
              <td class="sorting_1">{{index + 1}}</td>
              <td>
                <div class="row">
                  <div class="col-xs-8" v-for="item in item.item_list">
                    <span v-if="type === 'alias'">{{item.name}}</span>
                    <span v-if="item.type === 1">{{item.description}}</span>
                  </div>
                  <div class="col text-right" v-if="type === 'description' && checkEmptyBtnShow(item.item_list, 1)">
                    <button class="btn btn-danger" @click="emptyDescrption(item.item_list, item.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                  </div>
                </div>
              </td>
              <td v-if="type === 'description'">
                <div class="row">
                  <div class="col-xs-8" v-for="item in item.item_list">
                    <span v-if="item.type === 2">{{item.description}}</span>
                  </div>
                  <div class="col text-right" v-if="checkEmptyBtnShow(item.item_list, 2)"><button class="btn btn-danger" @click="emptyWarning(item.item_list, item.id)"><i class="fa fa-trash" aria-hidden="true"></i></button></div>
                </div>
              </td>
              <td>
                <div>{{item.product_name}}</div>
              </td>
              <td>
                <div>{{item.vendor_custom_id}}</div>
              </td>
              <td>
                <label class="label label-success" v-if="item.is_enabled">啟用</label>
                <label class="label label-danger" v-else>停用</label>
              </td>
              <td>
                <button class="btn btn-primary" @click="upElement(item.id, type)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
              </td>
              <td>
                <div class="inline-block" @click="delElement(item.id, type)">
                  <button class="btn btn-danger" data-toggle="modal" data-target="#delDesAlisModal"><i class="fa fa-trash" aria-hidden="true"></i></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <paginate :pageAmount="pageAmount" :total="total" :isActive="isActive"
                :groupAmount="groupAmount" :clickPage="clickPage"
      >
      </paginate>
    </div>
  </div>
</template>
<script>
export default{
  props: {
    settingList: Array,
    meta: Object,
    tab: Number,
    getProductSettingList: Function,
    type: String,
    searchText: String,
    tableIndex: Number
  },
  data () {
    return {
      selectAllItem: false,
      vendorId: 'vendor_custom_id',
      show: {
        brand: false,
        menu: false,
        schedule: false,
        history: false,
        menuDetail: false
      },
      pageGroup: 1,
      groupAmount: 10,
      total: 0,
      count: 20
    }
  },
  methods: {
    selectAll () {
      const data = this.settingList.map(x => {
        return {
          ...x,
          selectItem: this.selectAllItem
        }
      })
      this.$emit('update:setting-list', data)
    },
    checkEmptyBtnShow (ary, type) {
      var description = ary.filter(x => x.type === 1)
      var warning = ary.filter(x => x.type === 2)
      if (type === 1 && warning.length === 0) {
        return false
      } else if (type === 1 && description.length === 0) {
        return false
      } else if (type === 2 && description.length === 0) {
        return false
      } else if (type === 2 && warning.length === 0) {
        return false
      }
      return true
    },
    emptyDescrption (ary, id) {
      let warningItems = ary.filter(x => x.type === 2).map(x => x.description)
      const data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: [],
        warning_list: warningItems
      }
      this.upProductDescription(data, id)
    },
    emptyWarning (ary, id) {
      let descriptionItems = ary.filter(x => x.type === 1).map(x => x.description)
      const data = {
        vendor_custom_id: this.vendor_custom_id,
        is_enabled: this.is_enabled,
        item_list: descriptionItems,
        warning_list: []
      }
      this.upProductDescription(data, id)
    },
    upProductDescription (data, id) {
      var url = 'store/' + this.$route.params.store_id + '/productDescriptionSetting/' + id
      this.getDataH('post', url, data, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '成功',
            text: response.data.description,
            duration: 3000,
            type: 'success',
            width: 400
          })
          window.location.reload()
        }
      })
    },
    delElement (settingId, type) {
      this.$emit('updateDel', settingId, type)
    },
    upElement (settingId, type) {
      const bId = this.$route.params.brand_id
      const sId = this.$route.params.store_id
      let url = ''
      if (type === 'alias') url = 'upProductAlias'
      else if (type === 'description') url = 'upProductDescription'
      this.$router.push({ path: (`/${url}/${bId}/${sId}/${settingId}`), query: this.$route.query })
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.$emit('updatePagination', index)
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    tab () {
      this.$emit('update:tableIndex', 1)
      this.selectAllItem = false
    },
    meta () {
      this.total = this.meta.total
      this.count = this.meta.size
    },
    settingList (val) {
      const data = val.filter(x => x.selectItem).map(x => x.id)
      this.$emit('selectItem', data)
    }
  }
}
</script>
<style lang="sass">
  .img-ad-table
    height: 50px
  .actions-td
    width: 80px
  .text-block
    white-space: pre;
  .title
    font-size: 24px
    font-weight: bold
</style>



// WEBPACK FOOTER //
// ProdSettingTable.vue?6bf8a092